import React, { createContext, useContext, useState, useEffect } from 'react';
import api from './api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setUser(null);
      setAuthLoading(false);
      return;
    }
    api.get('/auth/me')
      .then(r => { setUser(r.data || null); setAuthLoading(false); })
      .catch((err) => {
        if (err.response?.status === 403) {
          // Ruoli Discord rimossi → logout automatico
          localStorage.removeItem('token');
          localStorage.removeItem('impero_jwt_token'); // sync bridge estensione
          setUser(null);
          setAuthLoading(false);
          window.location.href = '/login?error=no_access';
          return;
        }
        setUser(null);
        setAuthLoading(false);
      });
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, authLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export default AuthContext;
